<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true}">
        <span class="margin-right">Certification</span>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top align-center text-align-center">
    <div class="cell small-4 large-4 medium-4 padding-right">
      @if (fieldHasNotes('certifications|submitterName') || reviewStates?.includes(applicationState) ) {
        <span>
          <view-notes [fieldName]="'certifications|submitterName'" [notes]="getFilteredNotes('certifications|submitterName')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <label>Submitter Name</label>

      <input type="text" formControlName="submitterName" />

    </div>

    <div class="cell small-4 large-4 medium-4">
      @if (fieldHasNotes('certifications|submitterTitle') || reviewStates?.includes(applicationState) ) {
        <span>
          <view-notes [fieldName]="'certifications|submitterTitle'" [notes]="getFilteredNotes('certifications|submitterTitle')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <label>Submitter Title</label>
      <input type="text" formControlName="submitterTitle" />

    </div>
    I certify that the information provided is true and accurate, to the best of my knowledge.

  </div>

</ng-container>